module.exports = __webpack_public_path__ + "static/media/avatar.95d88e2f.png";